/**
 * Calculate the absolute difference between two numbers
 * @ignore
 * @param {number} numA
 * @param {number} numB
 * @return {number}
 */
export default function length(numA, numB) {
    return Math.abs(numA - numB);
}
